import { useState, useEffect } from 'react';

const useCdpLoaded = () => {
  const [cdpLoaded, setCdpLoaded] = useState<boolean>(false);
  const isBrowser = typeof window !== 'undefined'; // Check if window is defined

  useEffect(() => {
    if (isBrowser) {
      const delay = 2000; // 2 seconds
      const timer = setTimeout(() => {
        if (window._boxeverq && window.Boxever) {
          setCdpLoaded(true);
        }
      }, delay);
      return () => clearTimeout(timer);
    }
    return () => 0;
  }, [isBrowser]);

  return cdpLoaded;
};

export default useCdpLoaded;
